/* eslint-disable import/prefer-default-export */
/* Populated by react-webpack-redux:action */





export const AUTH_USER = "AUTH_USER";
export const AUTH_USER_REJECTED = "AUTH_USER_REJECTED";
export const AUTH_USER_FULFILLED = "AUTH_USER_FULFILLED";

export const FETCH_USERS = "FETCH_USERS";
export const FETCH_USERS_REJECTED = "FETCH_USERS_REJECTED";
export const FETCH_USERS_FULFILLED = "FETCH_USERS_FULFILLED";



export const FETCH_CIP_IDEAS = "FETCH_CIP_IDEAS";
export const FETCH_CIP_IDEAS_REJECTED = "FETCH_CIP_IDEAS_REJECTED";
export const FETCH_CIP_IDEAS_FULFILLED = "FETCH_CIP_IDEAS_FULFILLED";


export const FETCH_CIP_IDEA = "FETCH_CIP_IDEA";
export const FETCH_CIP_IDEA_REJECTED = "FETCH_CIP_IDEA_REJECTED";
export const FETCH_CIP_IDEA_FULFILLED = "FETCH_CIP_IDEA_FULFILLED";


export const FETCH_CIP_FILES = "FETCH_CIP_FILES";
export const FETCH_CIP_FILES_REJECTED = "FETCH_CIP_FILES_REJECTED";
export const FETCH_CIP_FILES_FULFILLED = "FETCH_CIP_FILES_FULFILLED";

export const FETCH_CIP_GROUPS = "FETCH_CIP_GROUPS";
export const FETCH_CIP_GROUPS_REJECTED = "FETCH_CIP_GROUPS_REJECTED";
export const FETCH_CIP_GROUPS_FULFILLED = "FETCH_CIP_GROUPS_FULFILLED";

export const FETCH_CIP_GROUP_MANAGERS = "FETCH_CIP_GROUP_MANAGERS";
export const FETCH_CIP_GROUP_MANAGERS_REJECTED = "FETCH_CIP_GROUP_MANAGERS_REJECTED";
export const FETCH_CIP_GROUP_MANAGERS_FULFILLED = "FETCH_CIP_GROUP_MANAGERS_FULFILLED";


export const POST_CIP_IDEA = "POST_CIP_IDEA";
export const POST_CIP_IDEA_REJECTED = "POST_CIP_IDEA_REJECTED";
export const POST_CIP_IDEA_FULFILLED = "POST_CIP_IDEA_FULFILLED";

export const POST_CIP_PROGRESS = "POST_CIP_PROGRESS";
export const POST_CIP_PROGRESS_REJECTED = "POST_CIP_PROGRESS_REJECTED";
export const POST_CIP_PROGRESS_FULFILLED = "POST_CIP_PROGRESS_FULFILLED";


export const FETCH_EDIT_USER = "FETCH_EDIT_USER";
export const FETCH_EDIT_USER_REJECTED = "FETCH_EDIT_USER_REJECTED";
export const FETCH_EDIT_USER_FULFILLED = "FETCH_EDIT_USER_FULFILLED";

export const SAVE_USER = "SAVE_USER";
export const SAVE_USER_REJECTED = "SAVE_USER_REJECTED";
export const SAVE_USER_FULFILLED = "SAVE_USER_FULFILLED";


export const FETCH_CIP_DEPARTMENTS = "FETCH_CIP_DEPARTMENTS";
export const FETCH_CIP_DEPARTMENTS_REJECTED = "FETCH_CIP_DEPARTMENTS_REJECTED";
export const FETCH_CIP_DEPARTMENTS_FULFILLED = "FETCH_CIP_DEPARTMENTS_FULFILLED";


export const FETCH_CIP_GROUP = "FETCH_CIP_GROUP";
export const FETCH_CIP_GROUP_REJECTED = "FETCH_CIP_GROUP_REJECTED";
export const FETCH_CIP_GROUP_FULFILLED = "FETCH_CIP_GROUP_FULFILLED";

export const FETCH_CIP_MEMBERS = "FETCH_CIP_MEMBERS";
export const FETCH_CIP_MEMBERS_REJECTED = "FETCH_CIP_MEMBERS_REJECTED";
export const FETCH_CIP_MEMBERS_FULFILLED = "FETCH_CIP_MEMBERS_FULFILLED";


export const REMOVE_CIP_MEMBER = "REMOVE_CIP_MEMBER";
export const REMOVE_CIP_MEMBER_REJECTED = "REMOVE_CIP_MEMBER_REJECTED";
export const REMOVE_CIP_MEMBER_FULFILLED = "REMOVE_CIP_MEMBER_FULFILLED";


export const ADD_CIP_MEMBER = "ADD_CIP_MEMBER";
export const ADD_CIP_MEMBER_REJECTED = "ADD_CIP_MEMBER_REJECTED";
export const ADD_CIP_MEMBER_FULFILLED = "ADD_CIP_MEMBER_FULFILLED";


export const SAVE_CIP_GROUP = "SAVE_CIP_GROUP";
export const SAVE_CIP_GROUP_REJECTED = "SAVE_CIP_GROUP_REJECTED";
export const SAVE_CIP_GROUP_FULFILLED = "SAVE_CIP_GROUP_FULFILLED";


export const FETCH_CIP_GROUP_TRANSACTIONS = "FETCH_CIP_GROUP_TRANSACTIONS";
export const FETCH_CIP_GROUP_TRANSACTIONS_REJECTED = "FETCH_CIP_GROUP_TRANSACTIONS_REJECTED";
export const FETCH_CIP_GROUP_TRANSACTIONS_FULFILLED = "FETCH_CIP_GROUP_TRANSACTIONS_FULFILLED";



export const SAVE_CIP_TRANSACTION = "SAVE_CIP_TRANSACTION";
export const SAVE_CIP_TRANSACTION_REJECTED = "SAVE_CIP_TRANSACTION_REJECTED";
export const SAVE_CIP_TRANSACTION_FULFILLED = "SAVE_CIP_TRANSACTION_FULFILLED";

export const FETCH_INITIATIVE = "FETCH_INITIATIVE";
export const FETCH_INITIATIVE_REJECTED = "FETCH_INITIATIVE_REJECTED";
export const FETCH_INITIATIVE_FULFILLED = "FETCH_INITIATIVE_FULFILLED";


export const FETCH_INITIATIVES = "FETCH_INITIATIVES";
export const FETCH_INITIATIVES_REJECTED = "FETCH_INITIATIVES_REJECTED";
export const FETCH_INITIATIVES_FULFILLED = "FETCH_INITIATIVES_FULFILLED";

export const ADD_INITIATIVE = "ADD_INITIATIVE";
export const ADD_INITIATIVE_REJECTED = "ADD_INITIATIVE_REJECTED";
export const ADD_INITIATIVE_FULFILLED = "ADD_INITIATIVE_FULFILLED";

export const UPDATE_INITIATIVE = "UPDATE_INITIATIVE";
export const UPDATE_INITIATIVE_REJECTED = "UPDATE_INITIATIVE_REJECTED";
export const UPDATE_INITIATIVE_FULFILLED = "UPDATE_INITIATIVE_FULFILLED";

export const FETCH_INITIATIVE_TYPES = "FETCH_INITIATIVE_TYPES";
export const FETCH_INITIATIVE_TYPES_REJECTED = "FETCH_INITIATIVE_TYPES_REJECTED";
export const FETCH_INITIATIVE_TYPES_FULFILLED = "FETCH_INITIATIVE_TYPES_FULFILLED";


export const SAVE_INITIATIVE_TYPE = "SAVE_INITIATIVE_TYPE";
export const SAVE_INITIATIVE_TYPE_REJECTED = "SAVE_INITIATIVE_TYPE_REJECTED";
export const SAVE_INITIATIVE_TYPE_FULFILLED = "SAVE_INITIATIVE_TYPE_FULFILLED";

export const SAVE_INITIATIVE_COMMENT = "SAVE_INITIATIVE_COMMENT";
export const SAVE_INITIATIVE_COMMENT_REJECTED = "SAVE_INITIATIVE_COMMENT_REJECTED";
export const SAVE_INITIATIVE_COMMENT_FULFILLED = "SAVE_INITIATIVE_COMMENT_FULFILLED";


export const SAVE_INITIATIVE_DECISION = "SAVE_INITIATIVE_DECISION";
export const SAVE_INITIATIVE_DECISION_REJECTED = "SAVE_INITIATIVE_DECISION_REJECTED";
export const SAVE_INITIATIVE_DECISION_FULFILLED = "SAVE_INITIATIVE_DECISION_FULFILLED";


export const SEND_INITIATIVE_OPINION_REQUEST = "SEND_INITIATIVE_OPINION_REQUEST";
export const SEND_INITIATIVE_OPINION_REQUEST_REJECTED = "SEND_INITIATIVE_OPINION_REQUEST_REJECTED";
export const SEND_INITIATIVE_OPINION_REQUEST_FULFILLED = "SEND_INITIATIVE_OPINION_REQUEST_FULFILLED";


export const FETCH_INITIATIVE_JOURNALS = "FETCH_INITIATIVE_JOURNALS";
export const FETCH_INITIATIVE_JOURNALS_REJECTED = "FETCH_INITIATIVE_JOURNALS_REJECTED";
export const FETCH_INITIATIVE_JOURNALS_FULFILLED = "FETCH_INITIATIVE_JOURNALS_FULFILLED";


export const RE_ASSIGN_INITIATIVE = "RE_ASSIGN_INITIATIVE";
export const RE_ASSIGN_INITIATIVE_REJECTED = "RE_ASSIGN_INITIATIVE_REJECTED";
export const RE_ASSIGN_INITIATIVE_FULFILLED = "RE_ASSIGN_INITIATIVE_FULFILLED";

export const FETCH_COST_CENTERS = "FETCH_COST_CENTERS";
export const FETCH_COST_CENTERS_REJECTED = "FETCH_COST_CENTERS_REJECTED";
export const FETCH_COST_CENTERS_FULFILLED = "FETCH_COST_CENTERS_FULFILLED";



export const SAVE_REWARD = "SAVE_REWARD";
export const SAVE_REWARD_REJECTED = "SAVE_REWARD_REJECTED";
export const SAVE_REWARD_FULFILLED = "SAVE_REWARD_FULFILLED";

export const SET_INITIATIVE_FILTER = "SET_INITIATIVE_FILTER";


export const FETCH_SUMMARY_INFO = "FETCH_SUMMARY_INFO";
export const FETCH_SUMMARY_INFO_REJECTED = "FETCH_SUMMARY_INFO_REJECTED";
export const FETCH_SUMMARY_INFO_FULFILLED = "FETCH_SUMMARY_INFO_FULFILLED";



export const SET_LOCALE = "SET_LOCALE";
export const SET_LOCALE_REJECTED = "SET_LOCALE_REJECTED";
export const SET_LOCALE_FULFILLED = "SET_LOCALE_FULFILLED";



export const FETCH_MANAGER = "FETCH_MANAGER";
export const FETCH_MANAGER_REJECTED = "FETCH_MANAGER_REJECTED";
export const FETCH_MANAGER_FULFILLED = "FETCH_MANAGER_FULFILLED";















// WEBPACK FOOTER //
// ./actions/actionTypes.js